import React from "react";
import styles from "./style.module.css";
import chargerImage from "./Assets/chargers.webp";
import BulletList from "../../components/BulletList";
import Button from "../../components/Button";
import Heading from "../../components/Heading";

const ParkingProfitSection: React.FC = () => {
    return (
        <div className={styles['main-container']}>
            <div className='container'>
                <section className={styles.container}>
                    {/* Left Content */}
                    <div className={styles.left}>
                        <span className={styles.badge}>Benefits</span>
                        <Heading topBottomMargin={14}>Transform Your Parking Into Profit</Heading>
                        <p className={styles.description}>
                            BreatheEV's innovative reservation-based charging system helps property owners
                            maximize revenue while providing a premium amenity that attracts and retains tenants.
                        </p>

                        <BulletList items={
                            [
                                "Maximize occupancy rates through a value-add amenity",
                                "Enhance property value and attract eco-conscious tenants",
                                "Generate new monthly revenue stream with minimal effort",
                                "Reduce charger count needed with optimized scheduling",
                                "Improve tenant satisfaction and retention rates",
                                "Contribute to sustainability goals and reduce carbon footprint",
                            ]
                        } />


                        {/* <button className={styles.button}>Calculate Your Savings <span>➔</span></button> */}
                        {/* <Button style={{padding:'12px 25px', marginTop:'15px'}}>Calculate Your Savings <span>➔</span></Button> */}
                    </div>

                    {/* Right Content */}
                    <div className={styles.right}>
                        {/* <div className={styles.card}>
                            <h4>Case Study: Hampton East Apartments</h4>
                            <p className={styles.description}>
                                Increased tenant retention and created new revenue stream with BreatheEV
                                reservation-enabled chargers
                            </p>
                            <div className={styles.metrics}>
                                <div>
                                    <p className={styles.metricValue}>94%</p>
                                    <p className={styles.metricLabel}>Occupancy Rate</p>
                                </div>
                                <div>
                                    <p className={styles.metricValue}>$2.4K</p>
                                    <p className={styles.metricLabel}>Monthly Revenue</p>
                                </div>
                                <div>
                                    <p className={styles.metricValue}>12%</p>
                                    <p className={styles.metricLabel}>Retention Increase</p>
                                </div>
                            </div>
                        </div> */}
                        <div className={styles.imageWrapper}>
                            <img src={chargerImage} alt="EV Charger" className={styles.image} />
                        </div>
                    </div>
                </section>
            </div>
        </div>


    );
};

export default ParkingProfitSection;
